import { render, staticRenderFns } from "./SuspectedLogs.vue?vue&type=template&id=40864030&scoped=true&"
import script from "./SuspectedLogs.vue?vue&type=script&lang=ts&"
export * from "./SuspectedLogs.vue?vue&type=script&lang=ts&"
import style0 from "./SuspectedLogs.vue?vue&type=style&index=0&id=40864030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40864030",
  null
  
)

export default component.exports